export default function Contact() {
    return (
        <section className="contact" id="contact">
            <h2>Contact</h2>
            <div className="contact-text">
                <p>
                    If you’d like to get in touch, feel free to reach out via email at 
                    <a href="mailto:kss@gmail.com" className="contact-link"> here</a> or connect with me on 
                    <a href="https://www.linkedin.com/in/khaidemsandip/" target="_blank" rel="noopener noreferrer" className="contact-link"> LinkedIn</a>.
                </p>
                <p>Looking forward to hearing from you!</p>
            </div>
        </section>
    );
}
